import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Megaphone, PlusCircle, Trash2, Pencil, Image as ImageIcon, Send, Link as LinkIcon } from 'lucide-react';
import axiosInstance from '../../api/axiosInstance';

const DNAME = process.env.REACT_APP_DNAME;

const defaultAdContent = `<p><strong>🙏🏿नमस्कार साथियो 🙏🏿</strong></p>
<p><strong>GAME PLAY करने के लिए निचे दिए गये लिंक पर क्लिक करें&nbsp; &nbsp;</strong></p>
<p><strong>----Deva Bhai----</strong></p>
<p><strong>♕♕&nbsp;<span id="kname">Deva Bhai online khaiwal </span>&nbsp; ♕♕</strong></p>
<p><strong>⏰ लखनऊ किंग ----------- 12:30 PM</strong></p>
<p><strong>⏰ सदर बाजार ------------ 1:30 PM</strong></p>
<p><strong>⏰ ग्वालियर --------------- 2:30 PM</strong></p>
<p><strong>⏰ दिल्ली बाजार ----------- 2:50 PM</strong></p>
<p><strong>⏰ चेन्नई जंक्शन ---------- 3:50 PM</strong></p>
<p><strong>⏰ श्री गणेश -------------- 4:10 PM</strong></p>
<p><strong>⏰ यमुना सिटी ------------ 5:00 PM</strong></p>
<p><strong>⏰ फरीदाबाद ------------- 5:30 PM</strong></p>
<p><strong>⏰ कश्मीरी गेट ------------ 6:40 PM</strong></p>
<p><strong>⏰ अलवर ---------------- 7:20 PM</strong></p>
<p><strong>⏰ गाज़ियाबाद ------------- 8:40 PM</strong></p>
<p><strong>⏰ कोलकता नाइट ---------- 10:10 PM</strong></p>
<p><strong>⏰ गली ------------------ 11:20 PM</strong></p>
<p><strong>⏰ दिसावर ---------------- 1:30 AM</strong></p>
<p>============================<br />============================</p>
<p><strong>🤑 Rate list 💸</strong><br /><strong>जोड़ी रेट 10-------960</strong><br /><strong>हरूफ रेट 100-----960</strong></p>
<p>♕♕ &nbsp;<strong id="kname1">Deva Bhai online khaiwal </strong>♕♕</p>`;

function AdManager() {
  const [ads, setAds] = useState([]);
  const [submit, setSubmit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [adInfo, setAdInfo] = useState({ 
    _id: '',
    name: '', 
    phoneNo: '', 
    website: 'A1 Satta King',
    adContent: '',
    orderA1: 0,
    orderSattaBazar: 0
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const result = await axiosInstance.get('/getads');
      if (result?.data) setAds(result.data);
      else setAds([]);
    } catch (error) {
      toast.error('Error fetching ads');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdInfo(prev => ({ ...prev, [name]: value }));
  };

  const clearForm = () => {
    setAdInfo({ _id: '', name: '', phoneNo: '', website: 'A1 Satta King', adContent: '', orderA1: 0, orderSattaBazar: 0 });
    setSubmit(true);
    setIsFormOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const payload = {
      name: adInfo.name,
      phoneNo: adInfo.phoneNo,
      website: adInfo.website,
      adContent: adInfo.adContent,
      orderA1: adInfo.orderA1,
      orderSattaBazar: adInfo.orderSattaBazar
    };

    try {
      await axiosInstance.post('/addad', payload);
      toast.success('Ad added successfully');
      clearForm();
      getData();
    } catch (error) {
      toast.error('Error adding ad');
    } finally {
      setLoading(false);
    }
  };

  const submitUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      _id: adInfo._id,
      name: adInfo.name,
      phoneNo: adInfo.phoneNo,
      website: adInfo.website,
      adContent: adInfo.adContent,
      orderA1: adInfo.orderA1,
      orderSattaBazar: adInfo.orderSattaBazar
    };

    try {
      await axiosInstance.put('/updatead', payload);
      toast.success('Ad updated successfully');
      clearForm();
      getData();
    } catch (error) {
      toast.error('Error updating ad');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this ad?')) return;
    try {
      await axiosInstance.delete('/deletead', { data: { id } });
      toast.success('Ad deleted');
      getData();
    } catch (error) {
      toast.error('Error deleting ad');
    }
  };

  const handleUpdate = (ad) => {
    setSubmit(false);
    setAdInfo({
      _id: ad._id,
      name: ad.name,
      phoneNo: ad.phoneNo,
      website: ad.website || 'A1 Satta King',
      adContent: ad.adContent || '',
      orderA1: ad.orderA1 || 0,
      orderSattaBazar: ad.orderSattaBazar || 0
    });
    setIsFormOpen(true);
  };

  return (
    <>
      <div className="page-header">
        <h2>Ad Manager</h2>
        <p>Manage promotional banners, contact details, and route them to specific websites.</p>
      </div>

      <div className="card" style={{ marginBottom: 24 }}>
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
           <div className="card-title">
             <Megaphone size={16} /> Ad Management
           </div>
           {!isFormOpen && (
             <button className="btn btn-primary btn-sm" onClick={() => { clearForm(); setIsFormOpen(true); setSubmit(true); }}>
               <PlusCircle size={15} style={{ marginRight: '6px' }} /> Create New Ad
             </button>
           )}
        </div>

        {isFormOpen && (
          <div className="card-header" style={{ borderTop: '1px solid var(--border-color)', backgroundColor: 'var(--bg-card)' }}>
            <div className="card-title" style={{ fontSize: '1rem', color: 'var(--text-secondary)' }}>
              {submit ? 'Creating New Ad' : 'Updating Ad Details'}
            </div>
            <button className="btn btn-ghost btn-sm" onClick={clearForm}>
              Cancel
            </button>
          </div>
        )}
        
        {isFormOpen && (
        <div className="card-body">
          <form onSubmit={submit ? handleSubmit : submitUpdate}>
            <div className="form-grid" style={{ gridTemplateColumns: 'auto 1fr', gap: '24px' }}>
              
            <div className="form-grid form-grid-cols-2" style={{ alignContent: 'start', gridColumn: '1 / -1' }}>
                <div className="form-group">
                  <label className="form-label">Ad Name / Khaiwal Name</label>
                  <input type="text" name="name" value={adInfo.name} onChange={handleChange} className="form-input" placeholder="e.g. Deva Bhai" required />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Website Routing</label>
                  <select name="website" value={adInfo.website} onChange={handleChange} className="form-input" required>
                    <option value="A1 Satta King">A1 Satta King</option>
                    <option value="Satta Bazar">Satta Bazar</option>
                    <option value="Both">Both Websites</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">WhatsApp Number</label>
                  <input type="number" name="phoneNo" value={adInfo.phoneNo} onChange={handleChange} className="form-input" placeholder="e.g. 9876543210" required />
                </div>
              </div>

              <div className="form-grid form-grid-cols-2" style={{ alignContent: 'start', gridColumn: '1 / -1', marginTop: '12px' }}>
                <div className="form-group">
                  <label className="form-label">Order (A1 Satta King)</label>
                  <input type="number" name="orderA1" value={adInfo.orderA1} onChange={handleChange} className="form-input" placeholder="e.g. 1" />
                </div>
                <div className="form-group">
                  <label className="form-label">Order (Satta Bazar)</label>
                  <input type="number" name="orderSattaBazar" value={adInfo.orderSattaBazar} onChange={handleChange} className="form-input" placeholder="e.g. 1" />
                </div>
              </div>
              
            </div>

            <div className="form-group" style={{ marginTop: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <label className="form-label" style={{ marginBottom: 0 }}>Ad HTML Content</label>
                  <button 
                    type="button" 
                    className="btn btn-warning btn-sm" 
                    onClick={() => setAdInfo(prev => ({ ...prev, adContent: defaultAdContent }))}
                  >
                    Use Default Data
                  </button>
                </div>
                <textarea 
                  name="adContent" 
                  value={adInfo.adContent} 
                  onChange={handleChange} 
                  className="form-input" 
                  style={{ minHeight: '180px', fontFamily: 'monospace' }} 
                  required 
                />
            </div>

            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
              <button 
                type="submit" 
                className={`btn ${submit ? 'btn-primary' : 'btn-success'}`}
                disabled={loading}
                style={{ padding: '12px 32px' }}
              >
                <Send size={15} /> {loading ? 'Processing...' : submit ? 'Publish Ad' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
        )}
      </div>

      <div className="card">
        <div className="card-header">
           <div className="card-title">Active Ads</div>
        </div>
        <div className="table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Target Website</th>
                <th>A1 Order</th>
                <th>Bazar Order</th>
                <th>WhatsApp</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {ads.length === 0 ? (
                <tr><td colSpan="4" style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)' }}>No ads running currently.</td></tr>
              ) : (
                ads.map(ad => (
                  <tr key={ad._id}>
                    <td style={{ fontWeight: 600 }}>{ad.name}</td>
                    <td>
                      <span className={`badge ${ad.website === 'Both' ? 'badge-blue' : ad.website === 'A1 Satta King' ? 'badge-success' : 'badge-warning'}`}>
                        <LinkIcon size={12} style={{ marginRight: 4, display: 'inline' }} />
                        {ad.website}
                      </span>
                    </td>
                    <td>{ad.orderA1}</td>
                    <td>{ad.orderSattaBazar}</td>
                    <td>{ad.phoneNo}</td>
                    <td>
                      <div className="action-cell">
                        <button className="btn btn-warning btn-sm" onClick={() => handleUpdate(ad)}><Pencil size={13} /> Edit</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(ad._id)}><Trash2 size={13} /> Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default AdManager;
